export default __webpack_public_path__ + "static/media/ML.e2716ca9.svg";